import React, { useState } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Input, Steps, Button, Form, Radio, Space } from 'antd';
import "../styles/store.css";
import "../styles/preview.css";
import "../styles/checkout.css";
import { Select } from "antd";
import user from "../assets/user.png";
import mail from "../assets/mail.png";
import visa from "../assets/checkout/visa.png";
import credit from "../assets/checkout/credit.png";
import cash from "../assets/checkout/cash.png";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { Link } from 'react-router-dom';

const Checkout = () => {
    const [current, setCurrent] = useState(0);

    const next = () => {
        setCurrent(current + 1);
    };

    const prev = () => {
        setCurrent(current - 1);
    };

    const onFinish = (values) => {
        console.log('Form Data:', values);
    };

    const [phone, setPhone] = useState("");
    const [selected, setSelected] = useState("evaluation");

    const handleChange = (value) => {
        console.log(`selected ${value}`);
    };

    const onChange = (e) => {
        console.log(e);
    };

    const [value, setValue] = useState(1);
    const onChangeShipping = (e) => {
        console.log("radio checked", e.target.value);
        setValue(e.target.value);
    };

    const [pay, setPay] = useState("credit");
    const onChangePay = (e) => {
        console.log("radio checked", e.target.pay);
        setPay(e.target.value);
    };


    const [cardNumber, setCardNumber] = useState("");
    const [expiryDate, setExpiryDate] = useState("");
    const [cvv, setCvv] = useState("");

    const handleCardNumberChange = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, "");

        if (value.length > 16) {
            value = value.slice(0, 16);
        }
        value = value.replace(/(.{4})/g, "$1 ").trim(); 
        setCardNumber(value);
    };

    const handleExpiryDateChange = (e) => {
        let value = e.target.value;
        value = value
            .replace(/[^0-9/]/g, "")
            .replace(/(\d{2})(\d)/, "$1/$2")
            .slice(0, 5);
        setExpiryDate(value);
    };

    const handleCvvChange = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, "").slice(0, 3);
        setCvv(value);
    };

    return (
        <div className='px-20 max-lg:px-5 my-10 checkout'>
            <Link to="/cart" className='flex items-center text-[#283D63] font-semibold mb-5'>
                <LeftOutlined />
                <p className='ml-3'>Back to cart</p>
            </Link>
            <h2 className="text-[#14294F] text-3xl font-bold leading-relaxed mb-5">
                Checkout
            </h2>

            <div className='grid grid-cols-3 max-lg:grid-cols-1 gap-14 max-lg:gap-4'>
                <div className='lg:col-span-2'>
                    <Steps
                        current={current}
                        labelPlacement="vertical"
                        className='w-1/2 max-lg:w-full max-lg:flex-row'
                        items={[
                            { title: 'Shipment' },
                            { title: 'Payment' },
                        ]}
                    />

                    <div className="mt-8">
                        {current === 0 && (
                            <form>
                                <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 max-lg:gap-4">
                                    <div>
                                        <p className="text-[#283D63] font-semibold">
                                            First Name <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Input
                                            placeholder="Eg. Johnny"
                                            suffix={<img src={user} className="w-[15px]" />}
                                            className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                        />
                                    </div>
                                    <div>
                                        <p className="text-[#283D63] font-semibold">
                                            Last Name <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Input
                                            placeholder="Eg. Doe"
                                            suffix={<img src={user} className="w-[15px]" />}
                                            className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                        />
                                    </div>
                                </div>

                                <div className='mt-5'>
                                    <p className="text-[#283D63] font-semibold">
                                        Phone Number <span className="text-[#CC0F0F]">*</span>
                                    </p>

                                    <div dir="ltr">
                                    <PhoneInput
                                        defaultCountry="sa"
                                        value={phone}
                                        onChange={(phone) => setPhone(phone)}
                                        className={`bg-white w-full mt-2 rounded placeholder:text-black placeholder:text-xl placeholder:font-normal placeholder:font-Arimo`}
                                    />
                                    </div>
                                </div>

                                <div className='mt-5'>
                                    <p className="text-[#283D63] font-semibold">
                                        Email <span className="text-[#CC0F0F]">*</span>
                                    </p>
                                    <Input
                                        placeholder="Eg. Solimannhene16@gmail.com"
                                        suffix={<img src={mail} className="w-[20px]" />}
                                        className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                    />
                                </div>


                                <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 max-lg:gap-4 mt-5">
                                    <div>
                                        <p className="text-[#283D63] font-semibold">
                                            Country <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Select
                                            defaultValue="one"
                                            className="w-full mt-2"
                                            onChange={handleChange}
                                            options={[
                                                {
                                                    value: "two",
                                                    label: "Choose one or more services",
                                                },
                                                {
                                                    value: "one",
                                                    label: "Choose country",
                                                },
                                            ]}
                                        />
                                    </div>
                                    <div>
                                        <p className="text-[#283D63] font-semibold">
                                            City <span className="text-[#CC0F0F]">*</span>
                                        </p>
                                        <Select
                                            defaultValue="one"
                                            className="w-full mt-2"
                                            onChange={handleChange}
                                            options={[
                                                {
                                                    value: "two",
                                                    label: "Choose one or more services",
                                                },
                                                {
                                                    value: "one",
                                                    label: "Choose city",
                                                },
                                            ]}
                                        />
                                    </div>
                                </div>

                                <div className="mt-5">
                                    <p className="text-[#283D63] font-semibold">
                                        Address <span className="text-[#CC0F0F]">*</span>
                                    </p>
                                    <Input
                                        placeholder="Write tour address in details eg. place / Street / Building name / Apartment"
                                        className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                    />
                                </div>

                                <Radio.Group
                                    onChange={onChangeShipping}
                                    value={value}
                                    className="mt-5 text-lg text-[#525A6B]"
                                >
                                    <Space direction="vertical">
                                        <Radio value={1}>Express Delivery (65 SR)</Radio>
                                    </Space>
                                </Radio.Group>

                            </form>
                        )}

                        {current === 1 && (
                            <form>
                                <div className='bg-[#FCFBFA] py-5 lg:mr-10 rounded-2xl'>

                                    <div className='flex items-center justify-between bg-[#FCFBFA] rounded-2xl mx-7 max-lg:mx-3 py- lg:mr-10'>
                                        <Radio.Group
                                            onChange={onChangePay}
                                            value={pay}
                                            className=" text-lg text-[#525A6B]"
                                        >
                                            <Space direction="vertical">
                                                <Radio value="credit">Credit / Debit Card</Radio>
                                            </Space>
                                        </Radio.Group>
                                        <div>
                                            <img src={credit} className="w-[30px]" />
                                        </div>
                                    </div>

                                    <div className="my-5 mx-7 max-lg:mx-3">
                                        <div className="bg-white border-2 border-[#EAA182] rounded-3xl p-7">

                                            <div>
                                                <p className="text-[#283D63] font-semibold">
                                                    Card Name <span className="text-[#CC0F0F]">*</span>
                                                </p>
                                                <Input
                                                    placeholder="Eg. Johnny Noe"
                                                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                                />
                                            </div>

                                            <div className='mt-5'>
                                                <p className="text-[#283D63] font-semibold">
                                                    Card Number <span className="text-[#CC0F0F]">*</span>
                                                </p>
                                                <Input
                                                    placeholder="0000 0000 0000 0000"
                                                    value={cardNumber}
                                                    onChange={handleCardNumberChange}
                                                    suffix={<img src={visa} className="w-[70px]" />}
                                                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                                />
                                            </div>

                                            <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 mt-5">
                                                <div>
                                                    <p className="text-[#283D63] font-semibold">
                                                        Expiry Date <span className="text-[#CC0F0F]">*</span>
                                                    </p>
                                                    <Input
                                                        placeholder="MM/YY"
                                                        value={expiryDate}
                                                        onChange={handleExpiryDateChange}
                                                        className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                                    />
                                                </div>
                                                <div>
                                                    <p className="text-[#283D63] font-semibold">
                                                        Cvv <span className="text-[#CC0F0F]">*</span>
                                                    </p>
                                                    <Input
                                                        placeholder="123"
                                                        value={cvv}
                                                        onChange={handleCvvChange}
                                                        className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                                <div className='flex items-center justify-between bg-[#FCFBFA] rounded-2xl mt-7 max-lg:mx-3 px-5 py-4 lg:mr-10'>
                                    <Radio.Group
                                        onChange={onChangePay}
                                        value={pay}
                                        className="text-lg text-[#525A6B]"
                                    >
                                        <Space direction="vertical">
                                            <Radio value="cash">Cash on Delivery</Radio>
                                        </Space>
                                    </Radio.Group>
                                    <div>
                                        <img src={cash} className="w-[30px]" />
                                    </div>
                                </div>
                            </form>
                        )}
                    </div>
                </div>


                <div>
                    <div className="bg-[#FCFBFA] p-4 rounded-3xl">
                        <div className="bg-white border-2 border-[#EAA182] rounded-3xl py-6 text-lg">
                            <h3 className="text-[#14294F] text-2xl text-center font-bold leading-relaxed mb-5">
                                Order Summary
                            </h3>
                            <div className="flex items-center justify-between px-5">
                                <p className="text-[#737E91]">x2 Cage Lamp</p>
                                <p className="text-[#283D63]">200 SR</p>
                            </div>
                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">x1 Tornado Vase XXL</p>
                                <p className="text-[#283D63]">700 SR</p>
                            </div>

                            <hr className="border border-[#FBDED2] my-5" />

                            <p className="text-[#A5AFC0] text-base px-4">Shipping</p>
                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">Standard Shipping</p>
                                <p className="text-[#283D63]">45 SR</p>
                            </div>

                            <hr className="border border-[#FBDED2] my-5" />

                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">Sub-Total</p>
                                <p className="text-[#283D63]">945 SR</p>
                            </div>
                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">Discount</p>
                                <p className="text-[#283D63]">0 SR</p>
                            </div>
                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#737E91]">Tax (14%)</p>
                                <p className="text-[#283D63]">43 SR</p>
                            </div>

                            <hr className="border border-[#FBDED2] my-5" />

                            <div className="flex items-center justify-between mt-3 px-5">
                                <p className="text-[#283D63]">Order Total</p>
                                <p className="text-[#283D63] font-semibold text-xl">987 SR</p>
                            </div>
                        </div>

                        <div className="relative mb-5">
                            <div className="mt-8 flex items-center">
                                <button
                                    className="text-white rounded-xl px-10 py-3 font-semibold border-2 border-[#FE804A] absolute z-10"
                                    style={{
                                        background:
                                            "radial-gradient(50% 50% at 50% 50%, #FE6625 0%, #FFAB88 100%)",
                                    }}
                                >
                                    Verify
                                </button>
                                <Input
                                    placeholder="Add coupon code here"
                                    className="h-[52px] border-0 bg-white coupon_input relative z-0 w-2/3 ml-28"
                                />
                            </div>
                        </div>
                    </div>

                    {current === 0 && (
                        <button onClick={next}
                            className="bg-[#FE9B71] text-white rounded-full px-14 py-3 my-5 mx-auto font-semibold flex"
                        >
                            Continue
                        </button>
                    )}

                    {current === 1 && (
                        <button
                            className="bg-[#FE9B71] text-white rounded-full px-14 py-3 my-5 mx-auto font-semibold flex"
                        >
                            Submit Order
                        </button>
                    )}

                </div>
            </div>

        </div>
    );
};

export default Checkout;